import Button from "../../../components/shared/Button";
import { FaLongArrowAltRight } from "react-icons/fa";
import { cardInfos } from "../../../components/Data/datas";
import Card1 from "../../Academy/Courses_Cards/Card1";
import { Link } from "react-router-dom";
import {
  academyPath,
  quranPath,
  qiraatPath,
  learningToolsPath,
} from "../../../components/routes/path";

const CoursesLdDisplay = () => {
  return (
    <div className="p-2 flex flex-col gap-5  sm:px-20 bg-blue-100">
      <div className="h-1 w-14 bg-[#004C97] sm:mb-5"></div>
      <div className="flex flex-col sm:flex-row justify-between gap-5 mb-5">
        <h2 className="font-bold sm:text-6xl sm:leading-[0.7] text-4xl">
          Learning Materials
        </h2>
        <Link to={academyPath} className="flex items-start">
          <div className="relative self-center ">
            <Button
              btnBgColor={
                "hover:bg-[#004C97] bg-white hover:text-white border border-[#eaaeff ] "
              }
              btnColor={"text-[#eaaeff ]  hover:text-[#333333] "}
              btnText={"View All Materials "}
              padding={"px-8 py-2 transition-all  ease-in-out"}
            />
            <FaLongArrowAltRight className="absolute right-2 bottom-3 text-[#eaaeff ]" />
          </div>
        </Link>
      </div>
      <div className="flex flex-col gap-10">
        {cardInfos
          .filter((cardInfo) => cardInfo.id <= 3)
          .map((cardInfo) => (
            <Card1
              key={cardInfo.id}
              {...cardInfo}
              to={`${academyPath}/${cardInfo.id}`}
              toCategory={
                cardInfo.bookCaterory == "QUR'AN"
                  ? quranPath
                  : cardInfo.bookCaterory == "Key Principles of Qira’at"
                  ? qiraatPath
                  : cardInfo.bookCaterory == "Learning Tools" &&
                    learningToolsPath
              }
            />
          ))}
      </div>
    </div>
  );
};

export default CoursesLdDisplay;
